import { usePermission } from "hooks/usePermission"
import React, { useEffect } from "react"
import { useSelector } from "react-redux"
import { Navigate } from "react-router-dom"

const InvestorPermissionWrapper = ({ children, permission }) => {
  const { userType } = useSelector((state) => state.user)
  const { hasPermission } = usePermission()

  if (userType === "INVESTOR" && !hasPermission(permission))
    return (
      <Navigate
        to={{
          pathname: "/forbidden",
        }}
      />
    )

  return children
}

export default InvestorPermissionWrapper
